"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _pickReactKnownProp = require("pick-react-known-prop");

var _ProductImageGalleryThumbnailsItem = _interopRequireDefault(require("@sprinx/react-com/ProductImageGalleryThumbnailsItem"));

var useStyles = (0, _makeStyles.default)(function () {
  return (
    /* theme */
    {
      root: {
        display: 'flex',
        alignItems: 'center',
        '&$horizontal': {
          flexDirection: 'row'
        },
        '&$vertical': {
          flexDirection: 'column'
        }
      },
      horizontal: {},
      vertical: {},
      sliderWrapperInner: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        '&$horizontal': {
          width: 280,
          flexDirection: 'row'
        },
        '&$vertical': {
          height: '100%',
          flexDirection: 'column'
        }
      },
      thumbnail: {},
      thumbnailActive: {}
    }
  );
}, {
  name: 'SxComProductImageGalleryThumbnails'
});

function ProductDetailImageGalleryThumbnails(_ref) {
  var altDefault = _ref.altDefault,
      activeMediaIndex = _ref.activeMediaIndex,
      pClasses = _ref.classes,
      className = _ref.className,
      media = _ref.media,
      onChange = _ref.onChange,
      _ref$ThumbnailCompone = _ref.ThumbnailComponent,
      ThumbnailComponent = _ref$ThumbnailCompone === void 0 ? _ProductImageGalleryThumbnailsItem.default : _ref$ThumbnailCompone,
      variant = _ref.variant,
      visibleThumbnailsLimit = _ref.visibleThumbnailsLimit,
      size = _ref.size,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["altDefault", "activeMediaIndex", "classes", "className", "media", "onChange", "ThumbnailComponent", "variant", "visibleThumbnailsLimit", "size"]);
  var isHorizontal = variant === 'horizontal';
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();

  var handleImageChange = _react.default.useCallback(function (index) {
    return function () {
      if (onChange) onChange(index);
    };
  }, [onChange]);

  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      showAll = _React$useState2[0],
      setShowAll = _React$useState2[1]; // const handleShowAll = React.useCallback(() => setShowAll(true), []);


  _react.default.useEffect(function () {
    return setShowAll(false);
  }, [media]);

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _clsx.default)(classes.root, className, isHorizontal && classes.horizontal, variant === 'vertical' && classes.vertical)
  }, (0, _pickReactKnownProp.pickHTMLProps)(rest)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.sliderWrapperInner, isHorizontal && classes.horizontal, variant === 'vertical' && classes.vertical)
  }, media.slice(0, !showAll && visibleThumbnailsLimit || media.length).map(function (thumbnail, index) {
    return /*#__PURE__*/_react.default.createElement(ThumbnailComponent, {
      key: index.toString(),
      className: (0, _clsx.default)(classes.thumbnail, activeMediaIndex === index && classes.thumbnailActive),
      media: thumbnail,
      altDefault: altDefault,
      onClick: handleImageChange(index),
      size: size
    });
  }), !showAll && visibleThumbnailsLimit < media.length && /*#__PURE__*/_react.default.createElement(_Button.default, {
    size: "small",
    onClick: handleImageChange(3)
  }, t('com/imageGallery/thumbnailsMore', {
    number: media.length - 3
  }))));
}

process.env.NODE_ENV !== "production" ? ProductDetailImageGalleryThumbnails.propTypes = {
  activeMediaIndex: _propTypes.default.number,
  altDefault: _propTypes.default.arrayOf(_propTypes.default.shape({})),
  classes: _propTypes.default.shape({
    horizontal: _propTypes.default.string,
    root: _propTypes.default.string,
    sliderWrapper: _propTypes.default.string,
    sliderWrapperInner: _propTypes.default.string,
    thumbnail: _propTypes.default.string,
    thumbnailActive: _propTypes.default.string,
    vertical: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  media: _propTypes.default.arrayOf(_propTypes.default.shape({
    alt: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.shape({
      language: _propTypes.default.string.isRequired,
      text: _propTypes.default.string
    }))]),
    src: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.string))]).isRequired
  })),
  onChange: _propTypes.default.func,
  size: _propTypes.default.oneOf(['mini', 'small', 'normal', 'big']),
  ThumbnailComponent: _propTypes.default.elementType,
  variant: _propTypes.default.oneOf(['vertical', 'horizontal']),
  visibleThumbnailsLimit: _propTypes.default.number
} : void 0;
ProductDetailImageGalleryThumbnails.defaultProps = {
  activeMediaIndex: undefined,
  altDefault: undefined,
  classes: undefined,
  className: undefined,
  media: [],
  onChange: undefined,
  size: 'mini',
  ThumbnailComponent: undefined,
  variant: 'horizontal',
  visibleThumbnailsLimit: undefined
};
var _default = ProductDetailImageGalleryThumbnails;
exports.default = _default;